
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["stroke",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40","viewBox":"0 0 42.195 53.964"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 291","fill":"none","stroke":"#707070","stroke-miterlimit":"10","stroke-width":"2.5"}},[_c('path',{attrs:{"data-name":"Rectangle 184","d":"M5.034 11.933h32.13v34.753a6.028 6.028 0 01-6.03 6.027H11.062a6.028 6.028 0 01-6.028-6.027V11.933h0z"}}),_c('path',{attrs:{"data-name":"Path 550","d":"M40.945 8.767a3.172 3.172 0 01-3.163 3.164H4.413a3.164 3.164 0 110-6.327h33.369a3.161 3.161 0 013.163 3.163z"}}),_c('path',{attrs:{"data-name":"Path 551","d":"M28.258 4.414a3.192 3.192 0 01-.228 1.19H14.171a3.192 3.192 0 01-.228-1.19 3.172 3.172 0 013.163-3.164h7.979a3.168 3.168 0 013.173 3.164z"}}),_c('g',{attrs:{"data-name":"Group 290","stroke-linecap":"round"}},[_c('path',{attrs:{"data-name":"Line 35","d":"M28.9 18.576v25.488"}}),_c('path',{attrs:{"data-name":"Line 36","d":"M21.099 18.576v25.488"}}),_c('path',{attrs:{"data-name":"Line 37","d":"M13.298 18.576v25.488"}})])])])
          )
        }
      }
    